import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import styles from "./DemoBanner.module.css";

/**
 * Faixa no topo das telas pra quem navega sem conta: diz que os dados são de exemplo e leva pro
 * cadastro. É a única explicação que o visitante recebe antes de explorar, então fica sempre à
 * vista em vez de depender de ele tentar anotar alguma coisa.
 */
export function DemoBanner() {
  return (
    <div className={styles.banner}>
      <span className={styles.icon}>
        <Sparkles size={16} strokeWidth={2.2} />
      </span>
      <p className={styles.text}>
        <strong>Demonstração com dados de exemplo.</strong>
        {/* No celular só a frase curta: a faixa não pode empurrar o saldo pra fora da primeira tela. */}
        <span className={styles.more}>
          {" "}
          Crie sua conta pra anotar os seus gastos e ver tudo isso com os seus números.{" "}
          <Link to="/sobre" className={styles.link}>
            Como funciona
          </Link>
        </span>
      </p>
      <Link to="/cadastro" className={styles.cta}>
        Criar conta
      </Link>
    </div>
  );
}
